import { CircularProgress, Grid, Paper, Stack, Typography, useTheme, } from '@mui/material';
import { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, } from 'react-redux';
import { getDynamicSettingInfo, getQuotationInfoNavigationItem, getRentersInformation } from './utils';
import { breadcrumbAction, quotationsAction, tabNavigationAction, toastActions } from '../../_actions';
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useState } from 'react';
import QuotationInfoCardsWrapper from './QuotationInfoCardsWrapper';
import RowDetails from '../../components/RowDetails';
import RenterInformationTitle from './RenterInformationTitle';
import QuotationActionsButtonPopover from './QuotationActionsButtonPopover';
import { getQuotationDetails } from '../../apis/buyersGuideApis';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import DocumentViewer from '../../components/DocumentViewer';
import { URLS } from '../../apis/urls';
import { QuotationDocumentStatus } from '../../_helpers';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { DOCUMENT_ID_POLLING_CONFIG } from './constant';

const QuotationInfo = () => {
    const { t, } = useTranslation();
    const dispatch = useDispatch()
    const {id} = useParams()
    const theme = useTheme()
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [quotationDetails,setQuotationDetails] = useState()
    const [isQuotationDetailsLoading,setIsQuotationDetailsLoading] = useState(false)
    const [actionState, setActionState] = useState({ anchorEl: null, mode: null });
    const [documentViewer, setDocumentViewer] = useState({
        open: false,
        documents: null,
    });
    const documentStatus = quotationDetails?.quote?.documentStatus;
    const canProlong =(documentStatus === QuotationDocumentStatus.PENDING || documentStatus === QuotationDocumentStatus.TIMEOUT);
    const isClosed = quotationDetails?.quote?.selectedOptions?.some(o => o.status === 3) ?? false;
    const isQuotation = quotationDetails?.quote?.selectedOptions?.some(o => o.status === 2) ?? false;
    const hasDocument = isQuotation && !!(quotationDetails?.quote?.documentId && quotationDetails?.quote?.documentStatus);   
    const canWithdraw = documentStatus === QuotationDocumentStatus.PENDING
    const quoteId = quotationDetails?.quote?.id
    const location = useLocation();
    const from = location?.state?.from;
   
    const handleMenuSelect = (action) => {
        let file = null;

        switch(action){
            case 'quotation':
                if(isClosed)
                    file = quotationDetails?.quote?.signedQuotationFile;
                else
                    file = quotationDetails?.quote?.quotationFile;
                break;
            default:
                file = quotationDetails?.quote?.quotationFile;
                break;
        }

        if (!file?.id) return;

        setDocumentViewer({
            open: true,
            documents: [{
                uri: `${URLS.GET_ATTACHMENT}${file.id}`,
                name: file?.description,
                fileType: "application/pdf"
            }]
        });
    };
   const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };
   
    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openAction = (e, mode) => {
        setActionState({ anchorEl: e.currentTarget, mode });
    }

    useEffect(() => {
        const quotationInfoGridNavigation = getQuotationInfoNavigationItem(t,quotationDetails)
        dispatch(tabNavigationAction.setNavigationTab(quotationInfoGridNavigation.tabs))
        dispatch(breadcrumbAction.setBreadcrumbItem(quotationInfoGridNavigation.breadCrumbs))
    }, [dispatch, t,quotationDetails])

    useEffect(() => { return quotationsAction.clearQuotationsStore }, [])
    
    const handleCopyLink = (url) => {
        if (!url) return;
        
        navigator.clipboard.writeText(url)
            .then(() => {
                dispatch(toastActions.success(t('buyersGuide.quotation.copyLinkSuccess')));
            })
            .catch(() => {
                dispatch(toastActions.error(t('error.header')));
            });
    };
    
    const renters = getRentersInformation(t,quotationDetails);
    const dynamicSettings = getDynamicSettingInfo(t,quotationDetails,setDocumentViewer, handleCopyLink);


 const fetchQuestionDetails = async (loading = false,retryCount = 0) => {
         try {
        setIsQuotationDetailsLoading(loading);
        const response = await getQuotationDetails(id);
        setQuotationDetails(response.data);
        if (from === "generateQuotation" && !response?.data?.quote?.documentId && retryCount < DOCUMENT_ID_POLLING_CONFIG.MAX_RETRY) {
            setTimeout(() => {
                fetchQuestionDetails(loading,retryCount + 1);
            }, DOCUMENT_ID_POLLING_CONFIG.DELAY);

        } else {
            setIsQuotationDetailsLoading(false);
        }
    } catch (e) {
        console.log(e);
    }
    }

    useEffect(() => {
        fetchQuestionDetails(true)
    }, [])

     const file = isClosed? quotationDetails?.quote?.signedQuotationFile : quotationDetails?.quote.quotationFile;
    return (
        <>
        {isQuotationDetailsLoading ? <Stack
        sx={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          p: theme.spacing(1.25),
          height: "50vh"
        }}>
        <CircularProgress size={30} />
      </Stack> :
        <Box
            sx={{
                flexGrow: 1,
                bgcolor: grey[100],
                p: 2,
                overflow: "auto",
                height: "100%",
            }}>
            <Stack sx={{
                flexGrow: 1,
                my: 2,
            }} spacing={2}>
                <Paper sx={{ width: "100%", bgcolor: "common.white" }} elevation={0}>
                    <QuotationInfoCardsWrapper
                        title={
                            <RenterInformationTitle
                                openAction={openAction}
                                menuAnchorEl={menuAnchorEl}
                                handleMenuClick={handleMenuClick}
                                handleMenuClose={handleMenuClose}
                                handleMenuSelect={handleMenuSelect}
                                isClosed={isClosed}
                                hasDocument={hasDocument}
                                canProlong={canProlong}
                                canWithdraw={canWithdraw}
                                file={file}
                                quoteId={quoteId}
                            />
                        }
                    >
                        <Grid container sx={{ py: 1 }}>
                            <Grid sx={{ borderRight: { xs: "none", md: `1px dashed ${grey[200]}` } }}
                                size={{ xs: 12,sm:6, md: 4 }} >
                                <Grid container spacing={0.5} sx={{ px: 2 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography variant="subtitle2">
                                            {renters[0]?.title}
                                        </Typography>
                                    </Grid>
                                    {renters[0]?.details?.map((detail, idx) => (
                                        <Grid size={{ xs: 12 }} key={idx}>
                                            <RowDetails title={detail.title} value={detail.value} disabled={renters[0].isDisabled} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid sx={{ borderRight: { xs: "none", md: `1px dashed ${grey[200]}` } }}
                                size={{ xs: 12,sm:6, md: 4 }}
                            >
                                <Grid container spacing={0.5} sx={{ px: 2 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography variant="subtitle2" sx={{
                                            mt: { xs: 3, md: 0 },
                                            mb: { xs: 1.5, md: 0 }
                                        }}>
                                            {renters[1]?.title}
                                        </Typography>
                                    </Grid>
                                    {renters[1]?.details?.map((detail, idx) => (
                                        <Grid size={{ xs: 12 }} key={idx}>
                                            <RowDetails title={detail.title} value={detail.value} disabled={renters[1].isDisabled} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </QuotationInfoCardsWrapper>
                </Paper>

                <Paper sx={{ width: "100%", bgcolor: "common.white" }} elevation={0}>
                    <QuotationInfoCardsWrapper
                        title={<Typography variant="h6">{t("general.dynamicSettings")}</Typography>}
                    >
                        <Grid container sx={{ py: 1 }}>
                            <Grid sx={{borderRight: { xs: "none", md: `1px dashed ${grey[200]}` } }}
                                size={{ xs: 12,sm:6, md: 4 }}
                            >
                                <Grid container spacing={0.5} sx={{ px: 2 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography variant="subtitle2">
                                            {dynamicSettings[0]?.title}
                                        </Typography>
                                    </Grid>
                                    {dynamicSettings[0]?.details?.map((detail, idx) => (
                                        <Grid size={{ xs: 12 }} key={idx}>
                                            <RowDetails title={detail.title} value={detail.value} disabled={dynamicSettings[0].isDisabled} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid sx={{borderRight: { xs: "none", md: `1px dashed ${grey[200]}` } }}
                                size={{ xs: 12,sm:6, md: 4 }}
                            >
                                <Grid container spacing={0.5} sx={{ px: 2 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography variant="subtitle2" sx={{
                                            mt: { xs: 3, md: 0 },
                                            mb: { xs: 1.5, md: 0 }
                                        }}>
                                            {dynamicSettings[1]?.title}
                                        </Typography>
                                    </Grid>
                                    {dynamicSettings[1]?.details?.map((detail, idx) => (
                                        <Grid size={{ xs: 12 }} key={idx}>
                                            <RowDetails title={detail.title} value={detail.value} disabled={dynamicSettings[1].isDisabled} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </QuotationInfoCardsWrapper>
                </Paper>
            </Stack>
                    <DocumentViewer
                        open={documentViewer.open}
                        onClose={() => setDocumentViewer({ open: false, documents: null })}
                        documents={documentViewer.documents}
                    />
            {actionState.anchorEl && actionState.mode && (
                <QuotationActionsButtonPopover
                    anchorEl={actionState.anchorEl}
                    mode={actionState.mode}
                    onClose={() => setActionState({ anchorEl: null, mode: null })}
                    quotationDetails={quotationDetails}
                    fetchQuotationDetails={fetchQuestionDetails}
                />
            )}
        </Box>
}
        </>
    )
}

export default QuotationInfo
